module.exports = __webpack_public_path__ + "img/xst.416f8a9f.png";